// 风险防控
import risk from './risk/risk.js'
//廉政档案
import leader from './Archives'
//清风论坛
//亦廉课堂
import forum from './Forum'
//公共的接口
import common from './common'

// 审查调查
import shencha from './shencha/shencha.js'
// 党纪法规
import party from './party/party.js'
// 巡视巡察
import xunshi from './xunshi/xunshi.js'

// 监督举报
import report from './Report'
// 首页
import Home from './Home'
import homPage from './homePage'
import tabSet from './tabSet'
//系统简介
import sys from './sys/sys.js'
const Api = Object.assign({}, risk, shencha, party, xunshi, leader, forum, common, report, Home, homPage, sys, tabSet)
export default Api

